export default __webpack_public_path__ + "static/Chair-b839ccf01a6692d5c24a9ef3a783cdc8.mp4";